module.exports = __webpack_public_path__ + "img/iud-woman.1b56fee7.png";